export const CHECKOUT_URL = "https://ebookpoint.shop/cart/50674981994748:1";

export const MAIN_IMAGE =
  "https://cdn.magicpatterns.com/uploads/8B9cEmZZG3Xd5bG44gxDx4/ChatGPT_Image_Jul_26,_2026,_05_32_26_PM.png";

export interface Tomo {
  emoji: string;
  title: string;
  items: string[];
}

export const TOMOS: Tomo[] = [
  {
    emoji: "🧠",
    title: "TOMO 1 — Fundamentos de la Mente Competitiva",
    items: [
      "Por qué el 90% del rendimiento se decide en la cabeza",
      "El ciclo miedo-error-bloqueo (y cómo romperlo)",
      "Diagnóstico: tu perfil psicológico como competidor",
      "Diálogo interno: el saboteador silencioso",
      'Construir tu "identidad de competidor"',
    ],
  },
  {
    emoji: "😮‍💨",
    title: "TOMO 2 — Control de la Ansiedad y los Nervios",
    items: [
      "Ansiedad pre-competitiva: fisiología y gestión",
      "Técnicas de respiración y activación (arousal control)",
      'El síndrome del "jugar para no perder"',
      "Rutinas pre-partido/pre-carrera",
      "Protocolo de 5 minutos anti-pánico",
    ],
  },
  {
    emoji: "🎯",
    title: "TOMO 3 — Concentración y Foco en Competencia",
    items: [
      "Atención selectiva: qué mirar y qué ignorar",
      "Recuperar el foco tras un error (reset mental)",
      "Zonas de distracción: rivales, público, arbitraje",
      "Anclas de concentración (triggers físicos y verbales)",
      "Entrenar el foco fuera de la cancha",
    ],
  },
  {
    emoji: "💪",
    title: "TOMO 4 — Confianza y Autoestima Deportiva",
    items: [
      "De dónde viene realmente la confianza (no es motivación)",
      "Superar el síndrome del impostor deportivo",
      "Manejo de la crítica, comparación y redes sociales",
      "Construir un historial de éxitos (banco de confianza)",
      "Confianza post-lesión o post-mala racha",
    ],
  },
  {
    emoji: "🔥",
    title: "TOMO 5 — Presión, Competencia y Momentos Decisivos",
    items: [
      "Anatomía del choke (por qué fallamos en el momento clave)",
      "Visualización y ensayo mental de situaciones límite",
      'Gestión de rivalidades y partidos "trampa"',
      "Tie-breaks, penales, últimos minutos: protocolo mental",
      "Recuperación emocional post-derrota (24-48h)",
    ],
  },
  {
    emoji: "🏆",
    title: "TOMO 6 — Hábitos Mentales de Largo Plazo",
    items: [
      "Rutinas diarias del deportista mentalmente fuerte",
      "Journaling deportivo: qué registrar y por qué",
      "Setting de objetivos (proceso vs. resultado)",
      "Prevenir el burnout y la desmotivación crónica",
      "Plan de entrenamiento mental de 90 días",
    ],
  },
];

export interface Bono {
  title: string;
  image: string;
}

export const BONOS: Bono[] = [
  {
    title: "Bono 1 — Cuaderno de Visualización Guiada (10 protocolos)",
    image:
      "https://cdn.magicpatterns.com/uploads/oKryZYpY92NF1YRuCNjSyp/ChatGPT_Image_Jul_26,_2026,_10_38_19_PM.png",
  },
  {
    title: "Bono 2 — Excel: Tracker de Estado Mental (30 días, con dashboard)",
    image:
      "https://cdn.magicpatterns.com/uploads/fu8a72kkgsvVyTedsRrwkA/ChatGPT_Image_Jul_26,_2026,_10_38_22_PM.png",
  },
  {
    title: "Bono 3 — Baraja de 40 Tarjetas de Reencuadre",
    image:
      "https://cdn.magicpatterns.com/uploads/wRUzCPHgnKhKWaQKJk5Pt3/ChatGPT_Image_Jul_26,_2026,_10_38_23_PM.png",
  },
  {
    title: "Bono 4 — Excel: Diario de Objetivos SMART Deportivos",
    image:
      "https://cdn.magicpatterns.com/uploads/hoMcPDpqEAz8fuKASs3m2r/ChatGPT_Image_Jul_26,_2026,_10_38_24_PM.png",
  },
  {
    title: "Bono 5 — Protocolo Anti-Choke (ficha imprimible)",
    image:
      "https://cdn.magicpatterns.com/uploads/shp5NUEJTX2PK8ffhNE85C/ChatGPT_Image_Jul_26,_2026,_10_38_25_PM.png",
  },
  {
    title: "Bono 6 — Checklist de Rutina Pre-Competitiva Editable",
    image:
      "https://cdn.magicpatterns.com/uploads/5L9S2WPxfz5tAEEQL78RTr/ChatGPT_Image_Jul_26,_2026,_10_38_26_PM.png",
  },
];

export const PROBLEMAS: string[] = [
  "Sientes ansiedad y nervios incontrolables antes y durante la competición.",
  "Tu cabeza se bloquea en el momento decisivo y fallas lo que sabes hacer.",
  "Te cuesta gestionar la frustración y el enfado tras un error.",
  "La falta de confianza y el miedo a fallar te impiden dar lo mejor de ti.",
  "El diálogo interno negativo y la comparación constante te desgastan mentalmente.",
];

export interface Review {
  name: string;
  email: string;
  subject: string;
  body: string;
}

export const GMAIL_REVIEWS: Review[] = [
  {
    name: "Carlos M.",
    email: "carlos.mrtnz@gmail.com",
    subject: "Gracias, cambió mi forma de competir",
    body:
      "Llevaba meses bloqueándome en los partidos importantes. Con el protocolo anti-pánico del Tomo 2 por fin salgo a competir tranquilo. Brutal.",
  },
  {
    name: "Lucía Fernández",
    email: "lucia.fdz@gmail.com",
    subject: "El kit que necesitaba",
    body:
      "El tracker de estado mental me abrió los ojos. Ahora entiendo mis rachas malas y sé cómo salir de ellas. Totalmente recomendable.",
  },
  {
    name: "Javier R.",
    email: "javi.ruiz88@gmail.com",
    subject: "Se nota en la cancha",
    body:
      "Los ejercicios de foco del Tomo 3 son oro puro. Recupero la concentración tras un error en segundos. 10/10.",
  },
  {
    name: "Marta Gómez",
    email: "marta.gomez@gmail.com",
    subject: "Muy completo y práctico",
    body:
      "Pensé que sería teoría, pero está lleno de protocolos aplicables. Las tarjetas de reencuadre las uso cada semana.",
  },
];

export interface Opinion {
  name: string;
  city: string;
  text: string;
}

export const OPINIONES: Opinion[] = [
  {
    name: "Sergio Navarro",
    city: "Valencia",
    text: "Nunca pensé que mi mente estuviera saboteando tanto mi juego. Este kit me devolvió la confianza que había perdido tras una lesión.",
  },
  {
    name: "Ana Torres",
    city: "Sevilla",
    text: "El plan de 90 días es un antes y un después. Voy a los torneos con una calma que antes no tenía. Merece muchísimo la pena.",
  },
  {
    name: "David Ortega",
    city: "Bilbao",
    text: "Muy bien explicado y directo al grano. El protocolo mental para penales me salvó en la final de liga. Increíble.",
  },
  {
    name: "Paula Ruiz",
    city: "Zaragoza",
    text: "Como entrenadora, se lo he recomendado a todos mis atletas. Herramientas reales, no motivación vacía.",
  },
];

export interface Testimonio {
  name: string;
  age: number;
  sport: string;
  city: string;
  text: string;
  time: string;
}

export const TESTIMONIOS: Testimonio[] = [
  {
    name: "Álvaro Giménez",
    age: 24,
    sport: "Fútbol semiprofesional",
    city: "Madrid",
    text: "Me ponía tan nervioso antes de los partidos que no rendía ni la mitad. Ahora tengo una rutina prepartido que me deja enchufado. Me ha cambiado la temporada.",
    time: "18:42",
  },
  {
    name: "Nerea Castro",
    age: 21,
    sport: "Atletismo",
    city: "A Coruña",
    text: "En las carreras me bloqueaba pensando en las rivales. El Tomo 3 me ha enseñado a centrarme en lo mío. He bajado mis marcas de verdad.",
    time: "11:08",
  },
  {
    name: "Iván Molina",
    age: 27,
    sport: "Pádel",
    city: "Málaga",
    text: "El síndrome de «jugar para no perder» era yo al cien por cien. Ahora salgo a ganar sin miedo. De las mejores compras que he hecho este año.",
    time: "20:16",
  },
  {
    name: "Cristina Vega",
    age: 23,
    sport: "Baloncesto",
    city: "Granada",
    text: "Después de un mal partido me venía abajo durante días. Con el protocolo de recuperación emocional le doy la vuelta en unas horas. Muy práctico.",
    time: "16:31",
  },
  {
    name: "Rubén Sáez",
    age: 29,
    sport: "Triatlón",
    city: "Alicante",
    text: "Pensaba que la cabeza no se podía entrenar. Me equivocaba. El diario de objetivos SMART me ha dado una constancia que no tenía. Muy recomendable.",
    time: "09:54",
  },
];

export interface Objecion {
  q: string;
  a: string;
}

export const OBJECIONES: Objecion[] = [
  {
    q: "¿Y si no tengo tiempo para leer 6 tomos?",
    a: "Está diseñado para deportistas ocupados. Cada capítulo es breve y directo, con protocolos de 5 minutos que puedes aplicar el mismo día. No necesitas leerlo todo de golpe.",
  },
  {
    q: "¿Sirve para mi deporte en concreto?",
    a: "Sí. Los principios de ansiedad, foco, confianza y presión son universales para cualquier deporte, individual o de equipo, amateur o profesional.",
  },
  {
    q: "¿Esto no es solo motivación de las de siempre?",
    a: "No. Es un método basado en psicología deportiva y ciencia del rendimiento, con herramientas prácticas, no frases motivadoras vacías.",
  },
  {
    q: "¿Cómo recibo el material?",
    a: "Es 100% digital (PDF + Excel). Recibes el acceso de forma inmediata en tu correo tras la compra. Sin esperas ni envíos.",
  },
  {
    q: "¿Y si no me convence?",
    a: "Es un pago único sin suscripciones ni sorpresas. El material es tuyo para siempre y puedes releerlo tantas veces como quieras.",
  },
];

// Ciudades y nombres para el pop-up de compra
export const POPUP_NAMES = [
  "María",
  "Carlos",
  "Laura",
  "Javier",
  "Elena",
  "Sergio",
  "Paula",
  "Diego",
  "Andrea",
  "Rubén",
  "Nerea",
  "Marc",
];

export const POPUP_CITIES = [
  "Madrid",
  "Barcelona",
  "Valencia",
  "Sevilla",
  "Bilbao",
  "Zaragoza",
  "Málaga",
  "Granada",
  "Alicante",
  "Murcia",
  "Vigo",
  "Palma",
];

export const COMPARISON = {
  without: [
    "Compites contra tu propia cabeza en cada partido",
    "Los nervios te bloquean en el momento clave",
    "Un error te hunde y condiciona todo el juego",
    "Tu confianza depende del último resultado",
    "Rindes muy por debajo de tu nivel real",
    "Improvisas sin método ni rutina mental",
  ],
  with: [
    "Sales a competir con la mente tranquila y concentrada",
    "Gestionas los nervios con protocolos probados",
    "Recuperas el foco tras un error en segundos",
    "Construyes una confianza sólida e independiente",
    "Rindes a tu verdadero nivel bajo presión",
    "Tienes un plan mental claro para cada situación",
  ],
};
